<template>
	<div class='admin'>
		<div class="container-fluid mt-5 px-0">
      		<div class="container py-5">
				<div class="d-flex flex-lg-row flex-column mt-3">
					<div class='admin__menu'>
						<div
							class='admin__menu__item'
							:key='route.path'
							v-for='route in routes.filter(x=>x.show)'
							:class='{ "admin__menu__item--selected" : route.route.includes(selected) }'
							@click='$router.push(`/${$store.state.meta.lang}/game/${getGameSeo()}/admin/` + route.route)'
						>
							<div>
								<font-awesome-icon :icon='["fa", route.icon]' class='admin__menu__item__icon' />
							</div>
							<div>
								<div class='admin__menu__item__title'>
									{{route.title}}
								</div>
								<div class='admin__menu__item__description'>
									{{route.description}}
								</div>
							</div>
						</div>
					</div>
					<router-view class='admin__router_view'></router-view>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Admin',
		data () {
			return {
				selected: null,
				routes: [
					{
						title: 'Dashboard',
						route: 'dashboard',
						description: 'Quick links and stats about your forum',
						icon: 'home',
						show: this.$store.getters.canViewReport
					},
					{
						title: `${ this.$t('forum_general') }`,
						route: 'general',
						description: 'Categories and settings',
						icon: 'th',
						show: this.$store.getters.canManageSetting
					},
					{
						title: 'Moderation',
						route: 'moderation/reports',
						description: 'View and respond to user reports',
						icon: 'exclamation-circle',
						show: this.$store.getters.canManageThread
					},
					{
						title: 'Users',
						route: 'users',
						description: 'View current user accounts and manage roles',
						icon: 'user-circle',
						show: this.$store.getters.canManageUser
					}
				]
			}
		},
		methods:{
			getGameSeo(){
				return this.$store.state.meta.gamesDict[this.$store.state.gameID].seoname || '';
			}
		},
		watch: {
			$route (to) {
				this.selected = to.path.split('/')[4]
			}
		},
		created () {
      		this.selected = this.$route.path.split('/')[4]

			this.$nextTick(() => {
				if(!this.$store.getters.isAdmin) {
					this.$router.push('/')
					this.$store.commit('setAccountTabs', 1)
					this.$store.commit('setAccountModalState', true)
				}
			})
		}
	}
</script>

<style lang='scss' scoped>
	@import '../../assets/scss/variables.scss';

	.admin {
		height: calc(100% + 1rem);
		margin-top: -1rem;
		display: flex;
		flex-direction: row;

		@at-root #{&}__menu {
			width: 23rem;
			height: calc(100%);
			cursor: default;
			overflow-y: auto;

			@at-root #{&}__item {
				transition: background-color 0.2s;
				padding: 1rem;
				border: 1px solid rgba(0, 255, 126, 0.25);
				display: flex;
				flex-direction: row;
				position: relative;
				color: #fff;

				&:hover {
					cursor: pointer;
				}

				@at-root #{&}--selected {
					border: 1px solid #00ff7f;

					&::before {
						left: 0;
					}
				}

				@at-root #{&}__icon {
					margin-right: 0.5rem;
					margin-top: 0.1875rem;
				}

				@at-root #{&}__title {
					font-weight: 600;
				}
				@at-root #{&}__description {
					font-size: 0.9rem;
					margin-top: 0.125rem;
				}
			}
		}

		@at-root #{&}__router_view {
			width: 100%;
			height: 100%;
			// overflow-y: auto;
		}
	}
</style>
